import {Theme, ThemeSpec} from './types';

export const Themes: Record<Theme, ThemeSpec> = {
  [Theme.Default]: {
    cellBorders: `line`,
    cellBorderHover: `none`,
    cellFocusable: false,
    cellHeaderBorders: `column-group`,
    cellBackground: `focus-on-hover`,
    rowHeight: 35,
    selectableRows: true,
    multimetricStyles: false,
  },
  [Theme.Funnels]: {
    cellBorders: `line`,
    cellBorderHover: `none`,
    cellFocusable: false,
    cellHeaderBorders: `column-group`,
    cellBackground: `focus-on-hover`,
    rowHeight: 35,
    selectableRows: true,
    multimetricStyles: false,
  },
  [Theme.Standalone]: {
    cellBorders: `line`,
    cellBorderHover: `outline`,
    cellFocusable: true,
    cellHeaderBorders: `column-group`,
    cellBackground: `focus-on-hover`,
    rowHeight: 35,
    selectableRows: false,
    multimetricStyles: true,
  },
  [Theme.Retention]: {
    cellBorders: `gap`,
    cellBorderHover: `outline`,
    cellFocusable: true,
    cellHeaderBorders: `none`,
    cellBackground: `heatmap`,
    rowHeight: 33,
    selectableRows: true,
    multimetricStyles: false,
  },
};
